import React, { useEffect, useState } from 'react';
import SearchIcon from '@material-ui/icons/Search';
import {
    TextField,
    Card,
    Breadcrumbs,
    Link,
    Typography,
    CardContent,
    Container,
    Grid,
    Backdrop,
    CircularProgress,
    Button,
    Snackbar,
    ThemeProvider,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { useTranslation } from 'react-i18next';
import Page from 'src/components/Page';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import moment from 'moment';
import axios from 'src/utils/axios';
import baseAxios from 'src/utils/baseAxios'
import { getUser } from 'src/utils/Common';
import Alert from 'src/components/Alert';
import trLocale from 'date-fns/locale/tr';
import DateFnsUtils from '@date-io/date-fns';
import { createMuiTheme } from '@material-ui/core/styles';
import { connect, useDispatch, useSelector } from 'react-redux';
import {
    KeyboardDatePicker,
    MuiPickersUtilsProvider
} from '@material-ui/pickers';
import { useHistory } from 'react-router-dom';
import Autocomplete from '@material-ui/lab/Autocomplete';
import {
    getTasksRequest
} from '../../store/actions';
import { sc } from 'src/utils/Common';
import SearchBar from 'material-ui-search-bar';
import { surveyActions, surveyThunks } from '../../store/slices/surveySlice'

const localeMap = {
    tr: trLocale
};

const locale = localStorage.getItem('i18nextLng');

const siyah = '#424242';


const materialTheme = createMuiTheme({
    palette: {
        primary: {
            contrastText: '#FFFFFF',
            dark: siyah,
            main: siyah,
            light: siyah
        }
    }
});


const useStyles = makeStyles(theme => ({
    overlay: {
        backgroundColor: 'rgba(0, 0, 0, 0)'
    },
    root: {
        paddingTop: theme.spacing(2),
        paddingBottom: theme.spacing(2),
        flexGrow: 1,
        backgroundColor: theme.palette.background.paper,
    },
    cardscontent: {
        minHeight: 300
    },
    backdrop: {
        zIndex: 1500,
        color: '#fff'
    },
    tableRow: {
        '&$hover:hover': {
            backgroundColor: '#E4DCCF'
        }
    },
    tableCell: {
        '$hover:hover &': {
            color: 'black'
        }
    },
    hover: {},
    searchB: {
        flexGrow: 1,
        height: 42,
        padding: theme.spacing(0, 2),
        display: 'flex',
        alignItems: 'center'
    },
    searchIconB: {
        marginRight: theme.spacing(0),
        color: theme.palette.icon
    },
    searchInputB: {
        flexGrow: 1
    },
    searchButtonB: {
        backgroundColor: theme.palette.common.white,
        marginLeft: theme.spacing(2)
    },
}));



const SurveyModule = ({ getTasksRequest }) => {
    const classes = useStyles();
    const { t } = useTranslation('overview');
    const SessionUser = getUser();
    const history = useHistory();
    const dispatch = useDispatch();
    const [openSnackbar, setOpenSnackbar] = React.useState(false);

    const [hoveredRowIndex, setHoveredRowIndex] = useState(null);
    const SurveyModuleData = useSelector((state) => state.survey.SurveyModuleData)
    const initialSurveyModuleData = useSelector((state) => state.survey.InitialSurveyModuleData)
    const loading = useSelector((state) => state.survey.loading) === 'Loading' ? true : false
    const SelectedStartDate = useSelector((state) => state.survey.startDate)
    const SelectedEndDate = useSelector((state) => state.survey.endDate)
    const searched = useSelector((state) => state.survey.searched)

    const StatusData = useSelector((state) => state.survey.closeStatusList)
    const SelectedStatus = useSelector((state) => state.survey.selectedStatus)

    const ServiceShopData = useSelector((state) => state.survey.serviceShopList)
    const SelectedServiceShop = useSelector((state) => state.survey.selectedServiceShop)

    const handleSnackbarClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        setOpenSnackbar(false);
    };

    const GetCloseStatus = () => {
        dispatch(surveyThunks.GetSiriusCloseStatus()).then((response) => {
            if (response.payload.length > 0 && response.payload.length === 1 && (SelectedStatus == null)) {
                dispatch(surveyActions.setSelectedStatus(response.payload[0]))
            }
        })
    }

    const GetServiceShopRequest = () => {
        dispatch(surveyThunks.GetServiceShop()).then((response) => {
            if(SelectedServiceShop == null){
                dispatch(surveyActions.setSelectedServiceShop(response.payload[0]))
            }
        })
    };

    useEffect(() => {
        GetServiceShopRequest();
        GetCloseStatus();
    }, []);

    const GetSurveyModule = () => {
        dispatch(surveyThunks.GetSurveyModuleData({
            serviceShopId: SelectedServiceShop.ServiceShopId,
            statusId: SelectedStatus.StatusId,
            startDate: SelectedStartDate,
            endDate: SelectedEndDate
        })).then((response) => {
            dispatch(surveyActions.setSurveyModuleData(response.payload))
        })
            .catch((error) => {

            })
    }

    const handleRoute = (WorkOrderId) => {
        axios
            .get('/GetConsumerByWorkOrderId/' + WorkOrderId + '/' + SessionUser.ServiceShopId + '/' + SessionUser.Role)
            .then(res => {
                const response = JSON.stringify(res.data[0]);
                sessionStorage.removeItem('SearhResult');
                sessionStorage.setItem('SearhResult', response);
                sessionStorage.removeItem('ConsumerId');
                sessionStorage.setItem('ConsumerId', res.data[0].ConsumerId);
                getTasksRequest(WorkOrderId);
                dispatch(surveyActions.setGoDirectlyToTheSurvey(true))
                history.push(`/WorkOrder/${WorkOrderId}/Anket`);
            }
            ).catch(err => { });
    }


    const handleMouseEnter = (index) => {
        setHoveredRowIndex(index);
    };

    const handleMouseLeave = () => {
        setHoveredRowIndex(null);
    };

    const changeStartDate = e => {
        dispatch(surveyActions.setStartDate(e))
    }

    const changeEndDate = e => {
        dispatch(surveyActions.setEndDate(e))
    }

    const requestSearch = (searchedVal) => {
        dispatch(surveyActions.setSearched(searchedVal))
        const filteredRows = initialSurveyModuleData.filter((item) => sc(
            item.CustomerName + item.Id + item.IssueTypeName + item.ProductSku + item.ServiceShop + item.WarrantyType + item.WorkCaseId + item.IsSurveyed,
            searchedVal
        ));
        dispatch(surveyActions.setSurveyModuleData(filteredRows));
    };

    const cancelSearch = () => {
        dispatch(surveyActions.setSearched(''))
        requestSearch(searched);
    };


    return (
        <Page>
            <Backdrop className={classes.backdrop} open={loading}>
                <CircularProgress color="inherit" />
            </Backdrop>
            <Snackbar
                open={openSnackbar}
                autoHideDuration={3000}
                onClose={handleSnackbarClose}
            >
                <Alert
                    onClose={handleSnackbarClose}
                />
            </Snackbar>
            <Container maxWidth="xl">
                <Breadcrumbs>
                    <Link color="inherit">Sirius</Link>
                    <Typography color="textPrimary">{t('lblSurveyModule')}</Typography>
                </Breadcrumbs>
                <br />
                <Card>
                    <CardContent>
                        <Grid container spacing={1}>
                            <Grid item xs={12} sm={2} lg={2}>
                                <Autocomplete
                                    size="small"
                                    fullWidth
                                    autoSelect
                                    disableClearable
                                    options={ServiceShopData || []}
                                    getOptionLabel={option => (option ? option.Dsc : '')}
                                    value={SelectedServiceShop || null}
                                    renderInput={params => (
                                        <TextField
                                            {...params}
                                            label={t('lblServiceShop')}
                                            variant="outlined"
                                        />
                                    )}
                                    onChange={(event, value) => {
                                        dispatch(surveyActions.setSelectedServiceShop(value));
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} sm={4} lg={4}>
                                <Autocomplete
                                    size="small"
                                    fullWidth
                                    autoSelect
                                    disableClearable
                                    options={StatusData || []}
                                    getOptionLabel={option => (option ? option.FieldText : '')}
                                    value={SelectedStatus || null}
                                    renderInput={params => (
                                        <TextField
                                            {...params}
                                            label={t('lblStatus')}
                                            variant="outlined"
                                        />
                                    )}
                                    onChange={(event, value) => {
                                        dispatch(surveyActions.setSelectedStatus(value))
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} sm={2} lg={2}>
                                <ThemeProvider theme={materialTheme}>
                                    <MuiPickersUtilsProvider
                                        utils={DateFnsUtils}
                                        locale={localeMap[locale]}
                                    >
                                        <KeyboardDatePicker
                                            color="primary"
                                            inputVariant="outlined"
                                            id="orderDate"
                                            size="small"
                                            invalidDateMessage={t('hatali_tarih')}
                                            format="dd.MM.yyyy"
                                            fullWidth
                                            label={t('lblStartDate')}
                                            variant="outlined"
                                            value={SelectedStartDate}
                                            onChange={e => changeStartDate(e)}
                                            KeyboardButtonProps={{ 'aria-label': 'change date' }}
                                        />
                                    </MuiPickersUtilsProvider>
                                </ThemeProvider>
                            </Grid>
                            <Grid item xs={12} sm={2} lg={2}>
                                <ThemeProvider theme={materialTheme}>
                                    <MuiPickersUtilsProvider
                                        utils={DateFnsUtils}
                                        locale={localeMap[locale]}
                                    >
                                        <KeyboardDatePicker
                                            color="primary"
                                            inputVariant="outlined"
                                            id="orderDate"
                                            size="small"
                                            invalidDateMessage={t('hatali_tarih')}
                                            format="dd.MM.yyyy"
                                            fullWidth
                                            label={t('lblEndDate')}
                                            variant="outlined"
                                            value={SelectedEndDate}
                                            onChange={e => changeEndDate(e)}
                                            KeyboardButtonProps={{ 'aria-label': 'change date' }}
                                        />
                                    </MuiPickersUtilsProvider>
                                </ThemeProvider>
                            </Grid>
                            <Grid item xs={12} sm={2} lg={2}>
                                <Button
                                    variant="contained"
                                    style={{
                                        backgroundColor: '#1E5128',
                                        color: 'white'
                                    }}
                                    fullWidth
                                    endIcon={<SearchIcon />}
                                    onClick={GetSurveyModule}
                                >
                                    {t('search')}
                                </Button>
                            </Grid>
                            <Grid
                                container
                                item
                                justify="space-between"
                                alignItems="center"
                                spacing={4}
                                xs={12}
                                sm={6}
                            >
                                <Grid item xs={6} sm={6}>
                                    <SearchBar
                                        placeholder={t('lblSearch')}
                                        value={searched}
                                        onChange={(searchVal) => requestSearch(searchVal)}
                                        onCancelSearch={() => cancelSearch()}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                    </CardContent>
                    <TableContainer className={classes.container}>
                        <Table
                            stickyHeader
                            aria-label="sticky table"
                            className={classes.table}
                            size="small"
                        >
                            <TableHead>
                                <TableRow>
                                    <TableCell align="left">{t('lblWorkOrderId')}</TableCell>
                                    <TableCell align="left">{t('lblWorkCaseId')}</TableCell>
                                    <TableCell align="left">{t('lblIsSurveyed')}</TableCell>
                                    <TableCell align="left">{t('lblNpsSurveyStatus')}</TableCell>
                                    <TableCell align="left">{t('lblCustomerName')}</TableCell>
                                    <TableCell align="left">{t('lblServiceShop')}</TableCell>
                                    <TableCell align="left">{t('lblPhoneNumber')}</TableCell>
                                    <TableCell align="left">{t('lblProductSku')}</TableCell>
                                    <TableCell align="left">{t('lblWarrantyType')}</TableCell>
                                    <TableCell align="left">{t('lblGlobalApplicationType')}</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {SurveyModuleData ? SurveyModuleData.map((row, index) => (
                                    <TableRow
                                        key={row.Id}
                                        hover
                                        classes={{ hover: classes.hover }}
                                        className={classes.tableRow}
                                        onClick={() => handleRoute(row.Id)}
                                        onMouseEnter={() => handleMouseEnter(index)}
                                        onMouseLeave={handleMouseLeave}
                                        style={{ cursor: hoveredRowIndex === index ? 'pointer' : 'default' }}
                                    >
                                        <TableCell align="left">
                                            {row.Id}
                                        </TableCell>
                                        <TableCell align="left">
                                            {row.WorkCaseId}
                                        </TableCell>
                                        <TableCell align="left">
                                            {row.IsSurveyed ? 'True' : 'False'}
                                        </TableCell>
                                        <TableCell align="left">
                                            {row.NpsSurveyStatus}
                                        </TableCell>
                                        <TableCell align="left">
                                            {row.CustomerName}
                                        </TableCell>
                                        <TableCell align="left">
                                            {row.ServiceShop}
                                        </TableCell>
                                        <TableCell align="left" sx={{ whiteSpace: 'normal', wordWrap: 'break-word' }}>
                                            {row.PhoneNumber.map((phone, index) => (
                                                <div key={index}>
                                                    {'+' + phone}
                                                    <br />
                                                </div>
                                            ))}
                                        </TableCell>
                                        <TableCell align="left">
                                            {row.ProductSku}
                                        </TableCell>
                                        <TableCell align="left">
                                            {row.WarrantyType}
                                        </TableCell>
                                        <TableCell align="left">
                                            {row.IssueTypeName}
                                        </TableCell>
                                    </TableRow>
                                )) : null}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Card>
            </Container>
        </Page >
    );
}
export default connect(state => ({
    tasks: state.tasks1,
}), {
    getTasksRequest,
})(SurveyModule);
